import classNames from "classnames";
import React from "react";

import useCheckLocation from "@hooks/useCheckLocation";

interface IProps {
  type?: "more" | "page";
  className?: string;
}

export default function Loading({ type = "more", className }: IProps) {
  const { isDanielJohnston } = useCheckLocation();

  return (
    <>
      {type === "more" && (
        <div
          className={classNames(
            "pc:col-span-12 pc:mb-15 pc:mt-15 z-20 col-span-8 mt-5 mb-10 place-self-center",
            className,
          )}
        >
          Loading...
        </div>
      )}
      {type === "page" && (
        <div
          className={classNames(
            isDanielJohnston ? "dark:bg-dj-black" : "dark:bg-black",
            "fixed inset-0 z-10 flex cursor-progress items-center justify-center bg-white dark:text-white",
            className,
          )}
        >
          Loading...
        </div>
      )}
    </>
  );
}
